import { DefaultError, QueryClient, QueryKey, useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { corporateCMSApi } from "~/Services";

interface Overview {
  id: number;
  title: string;
  image: string;
  published: boolean | string;
  created: string;
  changed: string;
  order_sequence: any;
}
interface milestoneLinks {
  id: string;
  field_text: string;
  field_link: string;
  parent_id: string;
  updated: string;
  published: string | boolean;
  created: string;
  order_sequence: any;
  field_achievement_order_sequence: any;
  parent_title: string;
}

const useOverview = (
  id: string,
  options?: UseQueryOptions<Overview, DefaultError, Overview, QueryKey>,
  queryClient?: QueryClient
): UseQueryResult<Overview, DefaultError> => {
  return useQuery<Overview, DefaultError, Overview, QueryKey>(
    {
      queryKey: ["milestoneOverview", id],
      enabled: false,
      queryFn: async (): Promise<Overview> => {
        const response = await corporateCMSApi.get<any>(`/api/airport-academy-achievement/${id}`);
        return response.data[0];
      },
      refetchOnWindowFocus: false,
      ...options,
    },
    queryClient
  );
};

const useLinks = (
  id: string,
  options?: UseQueryOptions<milestoneLinks, DefaultError, milestoneLinks, QueryKey>,
  queryClient?: QueryClient
): UseQueryResult<milestoneLinks, DefaultError> => {
  return useQuery<milestoneLinks, DefaultError, milestoneLinks, QueryKey>(
    {
      queryKey: ["milestoneLinks", id],
      enabled: false,
      queryFn: async (): Promise<milestoneLinks> => {
        const response = await corporateCMSApi.get<any>(`/api/airport-academy-achievement/paragraph/${id}`);
        return response.data[0];
      },
      refetchOnWindowFocus: false,
      ...options,
    },
    queryClient
  );
};

export { useLinks, useOverview };
